import { CreditDocuments } from '@interhyp/module-documents';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { COMMUNICATION_PLUGIN_ENABLED } from '../../../constants/env';
import { Navigation, NavItems } from '../../navigation/Navigation';

import '@interhyp/module-documents/esm/index.css';

export interface SubmissionDocumentsWrapperProps {
  providerId: string;
}

export function SubmissionDocumentsWrapper({
  providerId,
}: SubmissionDocumentsWrapperProps): JSX.Element {
  const { submissionId } = useParams<{ submissionId: string }>();
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/submissions/${submissionId}`, translation: 'navigation.summary' },
      { to: `/credit/submissions/${submissionId}/documents`, translation: 'navigation.documents' },
      ...(COMMUNICATION_PLUGIN_ENABLED
        ? [
            {
              to: `/credit/submissions/${submissionId}/communication`,
              translation: 'navigation.communication',
            },
          ]
        : []),
    ];
  }, [submissionId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <CreditDocuments submissionComponentId={submissionId} providerId={providerId} />
    </>
  );
}
